<template>
  <div>
    <VMessage
      type="warning"
      class="margin-below"
      subtype="outlined"
      :fullwidth="true"
      v-if="showPlanWarning">
      <template v-slot:icon>
        <ExclamationTriangleIcon />
      </template>
      <template v-slot:text>
        {{ $t('companySettings.billing.lowRemainingAllowance') }}
        <RouterLink
            :data-ec="`low_envelope_allowance_warning_${ec}`"
            data-et="admin-link-to-billing-subscription"
            to="/company-settings/billing"
            class="link-colour"
            v-if="showBillingLink">
          {{ $t('companySettings.billing.considerUpgrading') }}
        </RouterLink>
        <span v-else>{{ $t('companySettings.billing.contactAdmin') }}</span>
      </template>
    </VMessage>
    <VMessage
      type="warning"
      class="margin-below"
      subtype="outlined"
      :fullwidth="true"
      v-if="showPaygWarning">
      <template v-slot:icon>
        <ExclamationTriangleIcon />
      </template>
      <template v-slot:text>
        {{ $tc('companySettings.billing.remainingCredits', usage.credits, usage.credits ) }}
        <RouterLink
            :data-ec="`low_envelope_allowance_warning_${ec}`"
            data-et="admin-link-to-billing-payg"
            to="/company-profile/billing"
            class="link-colour"
            v-if="showBillingLink">
          {{ $t('companySettings.billing.invoicePreview.purchaseCreditsTitle') }}
        </RouterLink>
        <span v-else>{{ $t('companySettings.billing.contactAdmin') }}</span>
      </template>
    </VMessage>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import { ExclamationTriangleIcon } from '@/components/icons/fontIcons';

export default {
  name: 'VLowEnvelopeAllowanceWarning',
  components: {
    VMessage,
    ExclamationTriangleIcon,
  },
  props: {
    ec: {
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      company: 'company/company',
      currentPlan: 'plans/current',
      usage: 'metering/usage',
      userHasRole: 'roles/userHasRole',
    }),
    showPlanWarning() {
      return this.usage.plan && (this.usage.plan.allowance - this.usage.usage) < 5 && this.currentPlan.id !== 'pay-as-you-go';
    },
    showBillingLink() {
      return this.userHasRole('super-admin');
    },
    showPaygWarning() {
      return this.usage.credits < 5 && this.currentPlan?.id === 'pay-as-you-go';
    },
  },
  mounted() {
    this.$store.dispatch('company/GET').then(() => {
      if (this.company.new_billing_enabled) {
        this.$store.dispatch('plans/GET_CURRENT_PLAN');
        this.$store.dispatch('metering/GET_USAGE');
      }
    });
  },
};

</script>

<style scoped>
.link-colour {
  color: #e67e22;
}

.margin-below {
  margin-bottom: var(--spacing-small);
}
</style>
